class UsedCarComparisonList extends CarStorage {
    /**
     * @returns {string}
     */
    storageKey() {
        return 'used-car-comparison-list';
    }
}
